var currencyRegExp = /^[\$\u20ac]?[+-]?[0-9]{1,3}(?:[0-9]*(?:[.,][0-9]{2})?|(?:,[0-9]{3})*(?:\.[0-9]{2})?|(?:\.[0-9]{3})*(?:,[0-9]{2})?)[\$\u20ac]?$/i;
/**@type {import("./types").FormFieldValidator} */

export default (function (value) {
  var error = currencyRegExp.test(value) ? '' : 'Currency value is invalid';
  return error;
});